import React, { useState, useEffect } from 'react';
import './itemCard.css';
import './receipt.css';
import './bucket.css';
import { useNavigate } from 'react-router';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import ApiService from '../../services/apiService';
import Select from 'react-select';

const CustomerCreatePOpup = ({
  orderType,
  GetCostumer,
  close,
  selectedCustomer,
  address,
  onCustomerCreated, // Callback to handle customer creation success
}) => {
  let customer = selectedCustomer?.value;
  let navigate = useNavigate();

  const initialFormData = {
    id: '',
    name: '',
    idNumber: '',
    city: '',
    gender: '',
    address1: '',
    address2: '',
    address3: '',
    address4: '',
    phoneNumber: '',
    email: '',
    deliveryCharges: '',
    rider: '',
  };

  const [formData, setFormData] = useState(initialFormData);
  const [selectedAddress, setSelectedAddress] = useState('');
  const [currentSelectedAddress, setCurrentSelectedAddress] = useState('');
  const [isAddressChanged, setIsAddressChanged] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    if (name === currentSelectedAddress) {
      setIsAddressChanged(true);
    }
  };

  const handleAddressSelection = (e) => {
    const selectedAddress = e.target.value;
    setCurrentSelectedAddress(selectedAddress);
    setSelectedAddress(selectedAddress);
    if (selectedAddress && formData[selectedAddress]) {
      address?.(formData[selectedAddress]);
    }
  };

  useEffect(() => {
    if (customer) {
      setFormData({
        id: customer?.id,
        name: customer?.name,
        idNumber: customer?.idNumber,
        city: customer?.city,
        gender: customer?.gender,
        address1: customer?.address1,
        address2: customer?.address2,
        address3: customer?.address3,
        address4: customer?.address4,
        phoneNumber: customer?.mobileNumber || customer?.phoneNo1 || '',
        email: customer?.email,
        deliveryCharges: customer?.deliveryCharges || '',
        rider: customer?.rider || '',
      });
      setIsEditable(false);
    } else {
      // Reset form when no customer is selected
      setFormData(initialFormData);
      setIsEditable(true);
      setSelectedAddress('');
      setCurrentSelectedAddress('');
      setIsAddressChanged(false);
    }
  }, [customer]);

  const updateCustomerAddress = async () => {
    try {
      const updatedAddress = formData[currentSelectedAddress];
      if (!updatedAddress) return;

      const body = {
        customerId: formData.id,
        addressKey: currentSelectedAddress,
        addressValue: updatedAddress,
      };

      const apiService = new ApiService();
      let response = await apiService.put('UPDATE_CUSTOMER', body);

      if (response.data.statusCode === 200) {
        toast.success('Address updated successfully');
        setIsAddressChanged(false);
      } else {
        toast.warning(response.data.message || 'Failed to update address');
      }
    } catch (error) {
      console.error('Error updating address:', error);
      toast.error('An error occurred while updating the address');
    }
  };

  const handleNext = async () => {
    if (isAddressChanged) {
      await updateCustomerAddress();
    }
    close();
  };

  // ENHANCED: Customer creation with better error handling and auto-selection
  const handleAddCostumer = async () => {
    try {
      setIsLoading(true);

      // Enhanced validation
      if (!formData?.name?.trim()) {
        toast.warning('Please enter customer name');
        setIsLoading(false);
        return;
      }

      if (!formData?.phoneNumber?.trim()) {
        toast.warning('Please enter phone number');
        setIsLoading(false);
        return;
      }

      // // Validate phone number format (basic validation)
      // const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
      // if (!phoneRegex.test(formData.phoneNumber.trim())) {
      //   toast.warning('Please enter a valid phone number');
      //   setIsLoading(false);
      //   return;
      // }

      // Enhanced request body with better field mapping
      const body = {
        customerCategoryId: 1,
        address1: formData?.address1?.trim() || '',
        address2: formData?.address2?.trim() || '',
        address3: formData?.address3?.trim() || '',
        status: true,
        name: formData?.name?.trim(),
        identityCardNumber: formData?.idNumber?.trim() || '',
        mobileNumber: formData?.phoneNumber?.trim(),
        area: formData?.city?.trim() || '',
        gender: formData?.gender || '',
        phoneNo1: formData?.phoneNumber?.trim(),
        email: formData?.email?.trim() || '',
        enableLoyalty: true,
        password: '1234567',
        // Add delivery charges if it's a delivery order
        ...(orderType === 'Delivery' &&
          formData.deliveryCharges && {
            deliveryCharges: parseFloat(formData.deliveryCharges) || 0,
          }),
      };

      console.log('🚀 Creating customer with data:', body);

      const apiService = new ApiService();
      let response = await apiService.post('ADD_COSTUMER', body);

      console.log('📡 API Response:', response);

      if (response.data.statusCode === 201) {
        const newCustomerData = response.data.result;
        console.log('✅ Customer created successfully:', newCustomerData);

        toast.success(`Customer "${formData.name}" created successfully!`);

        // Reset form state
        setFormData(initialFormData);
        setSelectedAddress('');
        setCurrentSelectedAddress('');
        setIsAddressChanged(false);

        // Refresh customer list in parent component
        if (GetCostumer && typeof GetCostumer === 'function') {
          console.log('🔄 Refreshing customer list...');
          await GetCostumer();
        }

        // CRITICAL: Call the auto-selection callback
        if (onCustomerCreated && typeof onCustomerCreated === 'function') {
          console.log('🎯 Calling auto-selection callback...');
          await onCustomerCreated(newCustomerData);
        } else {
          console.warn('⚠️ No onCustomerCreated callback provided');
        }

        // Note: Don't close the modal here, let the parent handle it through the callback
      } else if (response?.data?.statusCode === 400) {
        const errorMessage = response?.data?.message || 'Failed to create customer';
        console.error('❌ Customer creation failed:', errorMessage);
        toast.warning(errorMessage);
      } else {
        console.error('❌ Unexpected response:', response);
        toast.error('Failed to create customer. Please try again.');
      }
    } catch (error) {
      console.error('❌ Error creating customer:', error);

      // Handle specific error types
      if (error.response?.status === 409) {
        toast.error('Customer with this phone number already exists');
      } else if (error.response?.status === 422) {
        toast.error('Invalid customer data. Please check all fields.');
      } else if (error.message?.includes('Network')) {
        toast.error('Network error. Please check your connection.');
      } else {
        toast.error('An error occurred while creating the customer');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleGenderChange = (selectedOption) => {
    setFormData({ ...formData, gender: selectedOption?.value || '' });
  };

  const handleRiderChange = (selectedOption) => {
    setFormData({ ...formData, rider: selectedOption?.value || '' });
  };

  // Enhanced validation for form submission
  const isFormValid = () => {
    return formData.name?.trim() && formData.phoneNumber?.trim() && !isLoading;
  };

  return (
    <Modal.Body>
      <div>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="mb-0">{customer ? 'Edit Customer' : 'Create New Customer'}</h5>
          {isLoading && (
            <div className="d-flex align-items-center text-primary">
              <span className="spinner-border spinner-border-sm me-2" role="status"></span>
              <small>Processing...</small>
            </div>
          )}
        </div>

        <div className="form-group row py-3">
          <div className="col-md-6">
            <label htmlFor="validationCustom01" className="form-label fw-bold">
              Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="p-2 form-control"
              id="validationCustom01"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              disabled={!isEditable || isLoading}
              placeholder="Enter customer name"
              style={{
                borderColor: !formData.name.trim() && formData.name !== '' ? '#dc3545' : '#ced4da',
              }}
            />
            {!formData.name.trim() && formData.name !== '' && <small className="text-danger">Name is required</small>}
          </div>
          <div className="col-md-6">
            <label htmlFor="validationCustom02" className="form-label fw-bold">
              Phone <span className="text-danger">*</span>
            </label>
            <input
              type="tel"
              className="p-2 form-control"
              id="validationCustom02"
              name="phoneNumber"
              value={formData?.phoneNumber}
              onChange={handleInputChange}
              required
              disabled={!isEditable || isLoading}
              placeholder="Enter phone number"
              style={{
                borderColor: !formData.phoneNumber && formData.mobileNumber !== '' ? '#dc3545' : '#ced4da',
              }}
            />
            {!formData.phoneNumber && formData.mobileNumber !== '' && <small className="text-danger">Phone number is required</small>}
          </div>
        </div>

        <div className="form-group row py-3">
          <div className="col-md-6">
            <label htmlFor="validationCustom03" className="form-label fw-bold">
              Email
            </label>
            <input
              type="email"
              className="p-2 form-control"
              id="validationCustom03"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              disabled={!isEditable || isLoading}
              placeholder="Enter email address"
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="validationCustom09" className="form-label fw-bold">
              Gender
            </label>
            <Select
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5' : null,
                  color: state.isFocused ? '#000' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000',
                  },
                }),
                control: (provided, state) => ({
                  ...provided,
                  opacity: isLoading ? 0.6 : 1,
                }),
              }}
              value={formData.gender ? { value: formData.gender, label: formData.gender } : null}
              onChange={handleGenderChange}
              options={[
                { value: 'Male', label: 'Male' },
                { value: 'Female', label: 'Female' },
                { value: 'Other', label: 'Other' },
              ]}
              isDisabled={!isEditable || isLoading}
              placeholder="Select gender"
              isClearable
            />
          </div>
        </div>

        <div className="form-group row py-3">
          <div className="col-md-6">
            <label htmlFor="validationCustomCity" className="form-label fw-bold">
              City
            </label>
            <input
              type="text"
              className="p-2 form-control"
              id="validationCustomCity"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
              disabled={!isEditable || isLoading}
              placeholder="Enter city"
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="validationCustomId" className="form-label fw-bold">
              ID Number
            </label>
            <input
              type="text"
              className="p-2 form-control"
              id="validationCustomId"
              name="idNumber"
              value={formData.idNumber}
              onChange={handleInputChange}
              disabled={!isEditable || isLoading}
              placeholder="Enter ID number"
            />
          </div>
        </div>

        {/* Address Section */}
        <div className="form-group mt-4">
          <h6 className="fw-bold mb-3">Address Information</h6>

          {/* Office Address */}
          <div className="mb-3">
            <label htmlFor="validationCustom07" className="form-label">
              Office Address
            </label>
            <div className="form-check row d-flex align-items-center">
              <div className="col-auto">
                <input
                  type="radio"
                  id="address1-radio"
                  name="defaultAddress"
                  value="address1"
                  checked={selectedAddress === 'address1'}
                  onChange={handleAddressSelection}
                  className="form-check-input"
                  disabled={isLoading}
                />
              </div>
              <div className="col">
                <input
                  type="text"
                  className="p-2 form-control"
                  id="validationCustom07"
                  name="address1"
                  value={formData.address1}
                  onChange={handleInputChange}
                  disabled={!isEditable || isLoading}
                  placeholder="Enter office address"
                />
              </div>
            </div>
          </div>

          {/* Home Address */}
          <div className="mb-3">
            <label htmlFor="validationCustom08" className="form-label">
              Home Address
            </label>
            <div className="form-check row d-flex align-items-center">
              <div className="col-auto">
                <input
                  type="radio"
                  id="address2-radio"
                  name="defaultAddress"
                  value="address2"
                  checked={selectedAddress === 'address2'}
                  onChange={handleAddressSelection}
                  className="form-check-input"
                  disabled={isLoading}
                />
              </div>
              <div className="col">
                <input
                  type="text"
                  className="p-2 form-control"
                  id="validationCustom08"
                  name="address2"
                  value={formData.address2}
                  onChange={handleInputChange}
                  disabled={!isEditable || isLoading}
                  placeholder="Enter home address"
                />
              </div>
            </div>
          </div>

          {/* Address 3 */}
          <div className="mb-3">
            <label htmlFor="validationCustom09" className="form-label">
              Additional Address 1
            </label>
            <div className="form-check row d-flex align-items-center">
              <div className="col-auto">
                <input
                  type="radio"
                  id="address3-radio"
                  name="defaultAddress"
                  value="address3"
                  checked={selectedAddress === 'address3'}
                  onChange={handleAddressSelection}
                  className="form-check-input"
                  disabled={isLoading}
                />
              </div>
              <div className="col">
                <input
                  type="text"
                  className="p-2 form-control"
                  id="validationCustom09"
                  name="address3"
                  value={formData.address3}
                  onChange={handleInputChange}
                  disabled={!isEditable || isLoading}
                  placeholder="Enter additional address"
                />
              </div>
            </div>
          </div>

          {/* Address 4 */}
          <div className="mb-3">
            <label htmlFor="validationCustom10" className="form-label">
              Additional Address 2
            </label>
            <div className="form-check row d-flex align-items-center">
              <div className="col-auto">
                <input
                  type="radio"
                  id="address4-radio"
                  name="defaultAddress"
                  value="address4"
                  checked={selectedAddress === 'address4'}
                  onChange={handleAddressSelection}
                  className="form-check-input"
                  disabled={isLoading}
                />
              </div>
              <div className="col">
                <input
                  type="text"
                  className="p-2 form-control"
                  id="validationCustom10"
                  name="address4"
                  value={formData.address4}
                  onChange={handleInputChange}
                  disabled={!isEditable || isLoading}
                  placeholder="Enter additional address"
                />
              </div>
            </div>
          </div>

          {/* Selected Address Display */}
          {selectedAddress && formData[selectedAddress] && (
            <div className="mt-3">
              <label htmlFor="selectedAddress" className="form-label fw-bold">
                Selected Default Address
                {selectedAddress === 'address1'
                  ? ' (Office)'
                  : selectedAddress === 'address2'
                  ? ' (Home)'
                  : selectedAddress === 'address3'
                  ? ' (Additional 1)'
                  : ' (Additional 2)'}
              </label>
              <div
                className="p-3 border rounded"
                style={{
                  backgroundColor: '#e9ecef',
                  fontWeight: '500',
                  color: '#495057',
                }}
              >
                {formData[selectedAddress]}
              </div>
            </div>
          )}
        </div>

        {/* Delivery Section for Delivery Orders */}
        {orderType === 'Delivery' && (
          <div className="form-group row py-4">
            <div className="col-md-12">
              <h6 className="fw-bold mb-3">Delivery Information</h6>
            </div>
            <div className="col-md-6">
              <label htmlFor="validationCustom06" className="form-label">
                Delivery Charges
              </label>
              <input
                type="number"
                step="0.01"
                className="p-2 form-control"
                id="validationCustom06"
                name="deliveryCharges"
                value={formData?.deliveryCharges}
                onChange={handleInputChange}
                disabled={!isEditable || isLoading}
                placeholder="Enter delivery charges"
                min="0"
              />
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="mt-4 d-flex gap-3">
          {isEditable ? (
            <>
              <button
                className="btn btn-primary flex-fill"
                onClick={handleAddCostumer}
                disabled={!isFormValid()}
                style={{
                  opacity: isFormValid() ? 1 : 0.6,
                  cursor: isFormValid() ? 'pointer' : 'not-allowed',
                  padding: '12px 24px',
                  fontSize: '16px',
                  fontWeight: '600',
                }}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Creating Customer...
                  </>
                ) : (
                  ' Create Customer'
                )}
              </button>
              <button
                className="btn btn-secondary"
                onClick={close}
                disabled={isLoading}
                style={{
                  padding: '12px 24px',
                  fontSize: '16px',
                }}
              >
                Cancel
              </button>
            </>
          ) : (
            <>
              <button
                className="btn btn-primary flex-fill"
                onClick={handleNext}
                disabled={isLoading}
                style={{
                  padding: '12px 24px',
                  fontSize: '16px',
                  fontWeight: '600',
                }}
              >
                ➡️ Use This Customer
              </button>
              <button
                className="btn btn-secondary"
                onClick={close}
                disabled={isLoading}
                style={{
                  padding: '12px 24px',
                  fontSize: '16px',
                }}
              >
                Cancel
              </button>
            </>
          )}
        </div>

        {/* Form Validation Summary */}
        {isEditable && (
          <div className="mt-3">
            <small className="text-muted">
              <span className="text-danger">*</span> Required fields
            </small>
          </div>
        )}
      </div>
    </Modal.Body>
  );
};

export default CustomerCreatePOpup;
